<script lang="ts">
export default {
  name: "rightHome",
};
</script>
<script setup lang="ts">
import * as echarts from 'echarts'
import { getEventStatistic } from "@/api/analysisApi/index"
import { getAlarmList } from "@/api/eventApi/index"
import { fontSize } from "@/common/common"
import { onMounted } from 'vue'
import BaseEcharts from '@/components/BaseEcharts/index.vue'
import { type EChartsCoreOption } from "@/hooks/useHookEchart"
import { store } from '@/store'
import router from '@/router';

const taskData1 = ref()
const eventChartTop1Options = computed(() => ({
  title: {
    text: taskData1.value + '%',
    left: 'center',
    top: 'center',
    itemGap: 0,
    textStyle: {
      color: '#54f3ff',
      fontSize: fontSize(1),
      fontWeight: '600',
      fontFamily: "YouSheBiaoTiHei",
    },
  },
  series: [
    /*仪表盘图，做中间刻度线*/
    {
      type: 'gauge',
      name: '',
      radius: '0%',
      startAngle: '0',
      endAngle: '-359.99',
      center: ['50%', '50%'],
      splitNumber: '80',
      pointer: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 20,
          opacity: 0
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        length: 7,
        lineStyle: {
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0, color: 'rgba(39, 183, 206, 0.32)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(191, 255, 159, 0.32)' // 100% 处的颜色
            }],
          },
          width: 2,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false
      }
    },
    /*内心原型图，展示整体数据概览*/
    {
      name: 'pie',
      type: 'pie',
      roundCap: true,
      clockwise: true,
      startAngle: 260,
      labelLine: {
        show: false
      },
      radius: ['85%', '100%'],
      emphasis: {
        scale: false
      },
      center: ['50%', '50%'],
      data: [
        {
          value: taskData1.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
              offset: 0,
              color: '#27b7ce'
            }, {
              offset: 1,
              color: '#bfff9f'
            }]),
            shadowColor: 'rgba(1,1,1,0.5)',
            shadowBlur: 1
          }
        },
        {
          value: 100 - taskData1.value,
          name: '',
          itemStyle: {
            color: '#54789b', // 未完成的圆环的颜色
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          },
          emphasis: {
            color: '#54789b' // 未完成的圆环的颜色
          }
        }]
    }
  ]
}))

const taskData2 = ref()
const eventChartTop2Options = computed(() => ({
  title: {
    text: taskData2.value + '%',
    left: 'center',
    top: 'center',
    itemGap: 0,
    textStyle: {
      color: '#54f3ff',
      fontSize: fontSize(1),
      fontWeight: '600',
      fontFamily: "YouSheBiaoTiHei",
    },
  },
  series: [
    /*仪表盘图，做中间刻度线*/
    {
      type: 'gauge',
      name: '',
      radius: '0%',
      startAngle: '0',
      endAngle: '-359.99',
      center: ['50%', '50%'],
      splitNumber: '80',
      pointer: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 20,
          opacity: 0
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        length: 7,
        lineStyle: {
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0, color: 'rgba(39, 183, 206, 0.32)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(191, 255, 159, 0.32)' // 100% 处的颜色
            }],
          },
          width: 2,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false
      }
    },
    /*内心原型图，展示整体数据概览*/
    {
      name: 'pie',
      type: 'pie',
      roundCap: true,
      clockwise: true,
      startAngle: 260,
      labelLine: {
        show: false
      },
      radius: ['85%', '100%'],
      emphasis: {
        scale: false
      },
      center: ['50%', '50%'],
      data: [
        {
          value: taskData2.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
              offset: 0,
              color: '#27b7ce'
            }, {
              offset: 1,
              color: '#bfff9f'
            }]),
            shadowColor: 'rgba(1,1,1,0.5)',
            shadowBlur: 1
          }
        },
        {
          value: 100 - taskData2.value,
          name: '',
          itemStyle: {
            color: '#54789b', // 未完成的圆环的颜色
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          },
          emphasis: {
            color: '#54789b' // 未完成的圆环的颜色
          }
        }]
    }
  ]
}))

const taskData3 = ref()
const eventChartTop3Options = computed(() => ({
  title: {
    text: taskData3.value + '%',
    left: 'center',
    top: 'center',
    itemGap: 0,
    textStyle: {
      color: '#54f3ff',
      fontSize: fontSize(1),
      fontWeight: '600',
      fontFamily: "YouSheBiaoTiHei",
    },
  },
  series: [
    /*仪表盘图，做中间刻度线*/
    {
      type: 'gauge',
      name: '',
      radius: '0%',
      startAngle: '0',
      endAngle: '-359.99',
      center: ['50%', '50%'],
      splitNumber: '80',
      pointer: {
        show: false
      },
      title: {
        show: false
      },
      detail: {
        show: false
      },
      axisLine: {
        lineStyle: {
          width: 20,
          opacity: 0
        }
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: true,
        length: 7,
        lineStyle: {
          color: {
            type: 'linear',
            colorStops: [{
              offset: 0, color: 'rgba(39, 183, 206, 0.32)' // 0% 处的颜色
            }, {
              offset: 1, color: 'rgba(191, 255, 159, 0.32)' // 100% 处的颜色
            }],
          },
          width: 2,
          type: 'solid',
        },
      },
      axisLabel: {
        show: false
      }
    },
    /*内心原型图，展示整体数据概览*/
    {
      name: 'pie',
      type: 'pie',
      roundCap: true,
      clockwise: true,
      startAngle: 260,
      labelLine: {
        show: false
      },
      radius: ['85%', '100%'],
      emphasis: {
        scale: false
      },
      center: ['50%', '50%'],
      data: [
        {
          value: taskData3.value,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
              offset: 0,
              color: '#27b7ce'
            }, {
              offset: 1,
              color: '#bfff9f'
            }]),
            shadowColor: 'rgba(1,1,1,0.5)',
            shadowBlur: 1
          }
        },
        {
          value: 100 - taskData3.value,
          name: '',
          itemStyle: {
            color: '#54789b', // 未完成的圆环的颜色
            label: {
              show: false
            },
            labelLine: {
              show: false
            },
          },
          emphasis: {
            color: '#54789b' // 未完成的圆环的颜色
          }
        }]
    }
  ]
}))

const dateArr = ref([])
const wzArr = ref([])
const gzhArr = ref([])
const eventOptions = computed(() => ({
  grid: {
    left: '35%',
    right: '10%',
    top: '15%',
    bottom: '8%'
  },
  tooltip: {
    trigger: 'item'
  },
  legend: {
    show: true,
    itemWidth: 20,
    itemHeight: 10,
    left: 'center',
    top: "5%",
    color: '#fff',
    icon: 'rect',
    textStyle: {
      color: '#fff',
      fontSize: fontSize(0.7),
    }
  },
  xAxis: {
    type: 'value',
    // "max": max,
    splitLine: {
      show: true,
      lineStyle: {
        color: '#232e32'
      }
    },
    axisLine: {
      show: false
    },
    axisLabel: {
      show: true,
      color: '#fff',
      fontSize: 12,
    },

    axisTick: {
      show: false
    }
  },
  yAxis: [
    {
      type: 'category',
      inverse: true,
      data: dateArr.value,
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        // "margin": 10,
        color: '#fff',
        fontSize: 12,
        padding: [0, 0, 0, 0] // 上右下左与原位置距离
      },
      textStyle: {

      }
    }
  ],
  series: [
    {
      //内
      type: 'bar',
      barWidth: 10,
      barGap: 0.1,
      name: '本周',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(20, 230, 182, 0)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(0, 230, 182, 1)' // 100% 处的颜色
            }
          ],
          false
        )
      },
      data: wzArr.value
    },
    {
      //内2
      type: 'bar',
      barWidth: 10,
      name: '上周',
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0,
          1,
          0,
          0,
          [
            {
              offset: 0,
              color: 'rgba(102, 178,255, 0)' // 0% 处的颜色
            },
            {
              offset: 1,
              color: 'rgba(102, 178,255, 1)' // 100% 处的颜色
            }
          ],
          false
        )
      },
      data: gzhArr.value
    }
  ]
}))

const organizationData: any = computed(() => store.informationListStore.informationStore().organizationData)

const eventStatisticList: any = ref([])

const chartsStatistic = () => {
  const params: any = {}
  params.statisticType = 1
  params.provinceCode = import.meta.env.VITE_APP_AREACODE,
    params.cityCode = organizationData.value.cityCode,
    params.areaCode = organizationData.value.areaCode,
    params.orgId = organizationData.value.provinceCode,
    getEventStatistic(params).then((res) => {
      console.log(res.list)
      eventStatisticList.value = res.list
      if (res.list.length <= 1) {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
      } else if (res.list.length <= 2) {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
        taskData2.value = parseInt(parseFloat(res.list[1].percent) * 100)
      } else if (res.list.length <= 3) {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
        taskData2.value = parseInt(parseFloat(res.list[1].percent) * 100)
        taskData3.value = parseInt(parseFloat(res.list[2].percent) * 100)
      } else {
        taskData1.value = parseInt(parseFloat(res.list[0].percent) * 100)
        taskData2.value = parseInt(parseFloat(res.list[1].percent) * 100)
        taskData3.value = parseInt(parseFloat(res.list[2].percent) * 100)
      }
    })
}

const barStatistic = () => {
  const lastWeekParams: any = {}
  lastWeekParams.statisticType = 2
  lastWeekParams.provinceCode = import.meta.env.VITE_APP_AREACODE
    lastWeekParams.cityCode = organizationData.value.cityCode,
    lastWeekParams.areaCode = organizationData.value.areaCode,
    lastWeekParams.orgId = organizationData.value.provinceCode,
    getEventStatistic(lastWeekParams).then((res) => {
      if(!dateArr.value.length){
        dateArr.value = res.list.map((result: any) => {
          return result.eventType
        })
      }
      wzArr.value = res.list.map((result: any) => {
        return result.eventNum
      })
    })

  const thisWeekParams: any = {}
  thisWeekParams.statisticType = 3
  thisWeekParams.provinceCode = import.meta.env.VITE_APP_AREACODE,
    thisWeekParams.cityCode = organizationData.value.cityCode,
    thisWeekParams.areaCode = organizationData.value.areaCode,
    thisWeekParams.orgId = organizationData.value.provinceCode,
    getEventStatistic(thisWeekParams).then((res) => {
      if(!dateArr.value.length){
        dateArr.value = res.list.map((result: any) => {
          return result.eventType
        })
      }
      gzhArr.value = res.list.map((result: any) => {
        return result.eventNum
      })
    })
}

const page = ref({
  page: 1,
  size: 8,
});

const searchValue = ref({
  position: "",
  eventType: "",
  startTime: "2020-01-01",
  endTime: "",
  gatewaySn: "",
  jobId: ""
});

const warningList: any = ref([])

async function AlarmList() {
  if (searchValue.value.gatewaySn) {
    searchValue.value.startTime = ""
  }
  const params = { ...page.value, ...searchValue.value } as any;
  const result = await getAlarmList(params);
  warningList.value = result.list;
}

const routeAnalysis = () => {
  router.push({
    path: "/analysis"
  })
}

const routeMonitor = () => {
  router.push({
    path: "/monitor"
  })
}

watch(() => store.informationListStore.informationStore().organizationData, (newVal, oldVal) => {
  console.log(newVal, oldVal)
  chartsStatistic()
  barStatistic()
}, {
  immediate: true,
  deep: true
})

onMounted(() => {
  AlarmList()
})
</script>

<template>
  <div class="right-home">
    <div class="analysis-box">
      <div class="big-title">综合分析</div>
      <div class="task-box">
        <div class="small-title">任务统计</div>
        <div class="day-word">七日内</div>
        <div class="event-list-box">
          <div class="chartBox" v-if="eventStatisticList.length > 0">
            <div style="color: #FF4848;">Top1.</div>
            <div class="eventChart">
              <base-echarts :options="eventChartTop1Options" />
            </div>
            <div class="eventtype">{{ eventStatisticList[0].eventType }}</div>
          </div>
          <div class="chartBox" v-if="eventStatisticList.length > 1">
            <div style="color: #FFCC00;">Top2.</div>
            <div class="eventChart">
              <base-echarts :options="eventChartTop2Options" />
            </div>
            <div class="eventtype">{{ eventStatisticList[1].eventType }}</div>
          </div>
          <div class="chartBox" v-if="eventStatisticList.length > 2">
            <div style="color: #FF7700;">Top3.</div>
            <div class="eventChart">
              <base-echarts :options="eventChartTop3Options" />
            </div>
            <div class="eventtype">{{ eventStatisticList[2].eventType }}</div>
          </div>
        </div>
      </div>
      <div class="event-statistics-box">
        <div class="small-title">事件分析</div>
        <div class="taskChart">
          <base-echarts :options="eventOptions" />
        </div>
      </div>
      <div class="more" style="bottom: -0.3125rem;" @click="routeAnalysis">查看更多>>></div>
    </div>
    <div class="monitor-box">
      <div class="big-title" style="margin-top: 0;">实时监控</div>
      <div class="small-title">事件图片</div>
      <div class="scroll_nav">
        <el-carousel class="swiper_box">
          <el-carousel-item class="box" v-for="(item, index) in warningList" :key="index">
            <img v-if="item.eventImages && item.eventImages.length" :src="item.eventImages[0].image" alt="">
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="more" @click="routeMonitor">查看更多>>></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.right-home {
  position: absolute;
  top: 7.5rem;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 21.1vw;
  height: 88vh;
  background: url("@/assets/images/right-monitor-bj.png") no-repeat center;
  background-size: 100% 100%;

  .analysis-box {
    width: 100%;
    height: 58.5vh;
    position: relative;

    .task-box {
      width: 100%;
      height: 21vh;
      margin: 0 auto;

      .day-word {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 1rem;
        color: #00FFD4;
        margin-left: 3.75rem;
        margin-top: .625rem;
      }

      .event-list-box {
        width: 80%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;

        .chartBox {
          margin-top: .625rem;

          div:nth-child(1) {
            font-weight: 600;
            font-size: 1rem;
            text-align: center;
            font-style: italic;
          }

          .eventChart {
            width: 5vw;
            height: 8.1vh;
            margin: 0.625rem auto;
          }

          div:nth-child(3) {
            font-weight: 400;
            font-size: 14px;
            color: #F6F9FE;
            text-align: center;
          }
        }
      }
    }

    .event-statistics-box {
      height: 27vh;
      margin-top: 0.625rem;

      .taskChart {
        width: 100%;
        height: 23vh;
      }

    }
  }

  .monitor-box {
    width: 100%;
    height: 31vh;
    position: relative;

    .scroll_nav {
      width: 90%;
      height: 18vh;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 0.625rem;
      margin-left: 1.25rem;
      .swiper_box {
        width: 100%;
        height: 100%;
        :deep(.el-carousel__container){
          width: 100%;
          height: 100%;
          border-radius: 10px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        :deep(.el-carousel__button){
          width: 0.31rem !important;
        }
      }
    }
  }
}
</style>
